import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("portal_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const shorten = (addr) =>
  addr ? `${addr.slice(0, 6)}\u2026${addr.slice(-4)}` : "";
